import React from 'react'
import Header from '../../Core/Header'
import { Section } from '../../Core/Section'

const GSTPurchaseReport = () => {
  return (
         <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="profit-loss-container">
          <h2 style={{fontSize:"20px"}}>Income Report</h2>
          {/* <div className="date-picker">
            <label>Select Date</label>
            <select
              value={dateRange}
              onChange={(e) => setDateRange(e.target.value)}
            >
              <option>March 6, 2025 - April 4, 2025</option>
              <option>Feb 1, 2025 - March 1, 2025</option>
            </select>
          </div> */}

          <div className="profit-summary" style={{display:"flex",justifyContent:"space-around"}}>
            <div className="summary-card" style={{borderRadius:"10px",backgroundColor:"#422efa",color:"white",padding:"20px",width:"280px"}}>
              <button className="export-btn" style={{borderRadius:"10px",backgroundColor:"#616161",color:"white",padding:"6px"}}>Export</button>
              <h3>Net Profit</h3>
              <p>₹ 1000</p>
            </div>
            <div className="summary-card" style={{borderRadius:"10px",backgroundColor:"#422efa",color:"white",padding:"20px",width:"280px"}}>
              <button className="export-btn" style={{borderRadius:"10px",backgroundColor:"#616161",color:"white",padding:"6px"}}>Export</button>
              <h3>Total Expenditure</h3>
              <p className= "negative" >
                ₹ 300
              </p>
            </div>
            <div className="summary-card" style={{borderRadius:"10px",backgroundColor:"#422efa",color:"white",padding:"20px",width:"280px"}}>
              <button className="export-btn" style={{borderRadius:"10px",backgroundColor:"#616161",color:"white",padding:"6px"}}>Export</button>
              <h3>Total Income</h3>
              <p className= "negative" >
                ₹ 200
              </p>
            </div>
          </div>

          <div className="report-sections"
          style={{display:"flex",width:"90%",gap:"10px",margin:"15px"}}>
            <div className="report-box" style={{width:"50%"}}>
              <button className="export-btn">Export</button>
              <h3>Monthly Expendeture</h3>
              <p>₹ 600</p>
             
                <div style={{ border:"1px solid grey",borderRadius:"10px",padding:"10px",marginBottom:"10px"}}>
                  <p>Month:5</p>
                  <p>Net Profit:100</p>
                  <p>Total Expendeture 200</p>
                  <p>Total Income 250</p>
                  </div>
             
              
            </div>

            <div className="report-box" style={{width:"50%"}}>
              <button className="export-btn">Export</button>
              <h3>Total Expense</h3>
              <p>₹ 500</p>
              
                <div style={{ border:"1px solid grey",borderRadius:"10px",padding:"10px",marginBottom:"10px"}}>
                  <p>Month:6</p>
                  <p>Net Profit: 700</p>
                  <p>Total Expendeture  400</p>
                  <p>Total Income  250</p>
                  </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GSTPurchaseReport
